import { render, staticRenderFns } from "./ReceiptsSetting.vue?vue&type=template&id=08a913ff&scoped=true&"
import script from "./ReceiptsSetting.vue?vue&type=script&lang=js&"
export * from "./ReceiptsSetting.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptsSetting.vue?vue&type=style&index=0&id=08a913ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a913ff",
  null
  
)

export default component.exports